
import { useQuery } from '@tanstack/react-query';
import { PipelineStageObject } from '@/types/pipeline';

/**
 * Hook to fetch pipeline stages - workspace context removed
 */
export const usePipelineStages = () => {
  const query = useQuery({
    queryKey: ['pipeline-stages'],
    queryFn: async (): Promise<PipelineStageObject[]> => {
      // Return static pipeline stages since workspace is disconnected
      return [
        { id: 'initial_contact', title: 'Initial Contact' },
        { id: 'qualified', title: 'Qualified' },
        { id: 'proposal', title: 'Proposal' },
        { id: 'negotiation', title: 'Negotiation' },
        { id: 'closed_won', title: 'Closed Won' },
        { id: 'closed_lost', title: 'Closed Lost' }
      ];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    pipelineStages: query.data || [],
    isLoading: query.isLoading,
    error: query.error
  };
};
